<template>
  <span class="loading-spinner" :class="[`size-${size}`]">
    <svg viewBox="0 0 24 24" fill="none">
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        class="spinner-track"
      />
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-dasharray="31.4 31.4"
        class="spinner-head"
      />
    </svg>
  </span>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  size?: 'xs' | 'sm' | 'md' | 'lg'
}>(), {
  size: 'md',
})
</script>

<style scoped>
.loading-spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: currentColor;
}

.size-xs {
  width: 12px;
  height: 12px;
}

.size-sm {
  width: 16px;
  height: 16px;
}

.size-md {
  width: 24px;
  height: 24px;
}

.size-lg {
  width: 32px;
  height: 32px;
}

.loading-spinner svg {
  width: 100%;
  height: 100%;
  transform-origin: center;
  animation: spin 1s linear infinite;
  will-change: transform;
}

.spinner-track {
  opacity: 0.2;
}

.spinner-head {
  transform-origin: center;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
